export function debounceAsync<R = void, A = unknown>(
  fn: (args?: A) => R,
  ms: number
): [(args: A) => Promise<R>, () => void] {
  let timer: number;

  const debouncedFunc = (args: A): Promise<R> =>
      new Promise((resolve) => {
          if (timer) {
              clearTimeout(timer);
          }

          timer = window.setTimeout(() => {
              resolve(fn(args));
          }, ms);
      });

  const teardown = () => clearTimeout(timer);

  return [debouncedFunc, teardown];
}
